<div
  apFoxitViewer
  rendererName="sign"
  [afterCreate]="afterCreateRenderer"
  width="100%"
  height="800px"
  class="ap-foxit-pdf-web-parent"
></div>
